<script context=module>
  // If remains just a dupe of same in FieldValueTable, refactor.
  export function isRowMatch(row1, row2) {
    return row1 && row2 &&
           row1.formid === row2.formid &&
           row1.formfieldid === row2.formfieldid
  }
</script>

<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  import SvelteTable from 'svelte-table'

  export let rows
  export let columns

  export let selectedRow

  let wrapdiv

  $: { findSelectedRowInRows(rows) }
  function findSelectedRowInRows(rowlist) {
    console.log('findSelectedRowInRows')
    const found = rows.find(v => isRowMatch(v, selectedRow))

    // If we found a row, ensure that the row is exact same object
    // as the row found in the rows collection.  If we did not find
    // a matching row, set selectedRow to null.
    selectedRow = !!found ? found : null
  }
 

  // Changed this from handleClickRow because we want row selection
  // to be consistent with row focus on mouse action.
  function handleMouseDownRow(e, row) {
    console.log(row)
    let selected = false
    if (isRowMatch(row, selectedRow)) {
      // Disable deselection, for now.  Might not need.
      //selectedRow = null
    } else {
      selected = true
      selectedRow = row
    }
    dispatch('rowclick', {row, selected})
  }


  async function handleKeydownOnRow(e, row) {
    if (['ArrowDown','ArrowUp'].includes(e.key)) {
      let newfocus = null
      if (e.key === "ArrowDown") {
        newfocus = e.target.nextElementSibling
      } else if (e.key === "ArrowUp") {
        newfocus = e.target.previousElementSibling
      }
      if (newfocus) {
        newfocus.focus()
        e.preventDefault()
        e.stopPropagation()
      }
    }
    const isRowSelected = e.target.classList.contains('selected')
    dispatch('rowkeydown', {row, key: e.key, isRowSelected})
  }

</script>

<div class=wrapdiv bind:this={wrapdiv} >
{#if rows}
<SvelteTable { rows } { columns }
             classNameTable=fieldvaluetable >
  <tr slot=row let:row let:n
      tabindex=0
      class:selected={ isRowMatch(row, selectedRow) }
      class:errorrow={ !!row.formfielderrorid }
      class:accepted={ row.errorstatus==='accepted' }
      on:mousedown={ e => handleMouseDownRow(e, row) }
      on:keydown={ e => handleKeydownOnRow(e, row) } >
    {#each columns as col}
      <td class={col.class}
      >{@html col.renderValue ? col.renderValue(row) : col.value(row)}</td>
    {/each}
  </tr>
</SvelteTable>
{/if}
</div>

<style>

  tr.selected {
    background-color: #e7e7e7;
  }
  /* So that outline is also visible on focus from mouse click. */
  tr:focus {
    outline: 2px solid black;
  }
  .errorrow .errorindicator {
    color: #d8000c;
    background-color: #ffdddd;
  }
  .accepted .errorindicator {
    background-color: #ffffcc;
  }
  .selected .errorindicator {
    background-color: inherit;
  }
  td {
    padding: 0 .2em 0 .4em;
    max-width: 20em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  tr.selected:focus td {
    white-space: normal;
  }
  td:not(:first-child) {
    border-left: 1px solid lightgray;
  }
  .wrapdiv :global(th input) {
    width: 95%;
  }
  .wrapdiv :global(th:not(:first-child)) {
    border-left: 1px solid lightgray;
  }
  .wrapdiv :global(thead) {
    background-color: gray;
    color: white;
    border-bottom: 1px solid lightgray;
  }

</style>

